define('ext/fancytree',[
  "globals",
  "jquery",
  "fancytree",
  "underscore",
  "templates"
], function (globals, $, fancytree, _, JST) {
  "use strict";

  var KEYPATH_SEPARATOR = "/";
  var VERSION_SEPARATOR = "+";
  var LANGUAGE_SEPARATOR = "|";
  var TRAIL_SEPARATOR = ".";

  // Patch Fancytree
  //
  // TODO: This is probably not the correct way to do extend FancyTree.
  $.extend($.ui.fancytree._FancytreeClass.prototype, {
    activateHref: function (href) {
      var node = this.getNodeByHref(href);

      if (node) {
        node.setActive();
      } else if (this.activeNode) {
        this.activeNode.setActive(false);
      }

      return node;
    },

    getNodeByHref: function (href, searchRoot) {
      var match = null;
      searchRoot = searchRoot || this.rootNode;

      searchRoot.visit(function (node) {
        if (_.isEqual(node.data.location, href)) {
          match = node;
          return false;
        }
      }, true);

      return match;
    },

    /**
    /* Make a FancyTree key path from a single key.
     *
     * @param {string} key A FancyTree node key. For example,
     *                     "org.oasis-open.dita_1.2.0+0.2.1.5".
     * @return {string} A full key path for the given key. For example:
     *
     *                  "org.oasis-open.dita_1.2.0+0/
     *                   org.oasis-open.dita_1.2.0+0.2/
     *                   org.oasis-open.dita_1.2.0+0.2.1/
     *                   org.oasis-open.dita_1.2.0+0.2.1.5"
     */
    makeKeyPath: function (k) {
      var components = k.split(VERSION_SEPARATOR),
        root = _.first(components),
        trail = _.last(components);

      return _.chain(trail.split(TRAIL_SEPARATOR))
        .reduce(function (memo, value, index, items) {
          // Take the items in the trail up until the current item.
          var prev = _.take(items, index),
            // Prepend the previous values to the current value to
            // create the key for the current item.
            key = prev.concat([value]);

          memo.push(root + VERSION_SEPARATOR + key.join(TRAIL_SEPARATOR));
          return memo;
        }, []).value().join(KEYPATH_SEPARATOR);
    },

    activateNodeByKey: function (key) {
      var keypath = this.makeKeyPath(key);

      this.loadKeyPath(keypath, function (node, msg) {
        if (msg === "error") {
          console.error("Couldn't load key path " + keypath + ".");
          return false;
        }

        node.setActive();
      });
    }
  });

  $.ui.fancytree.registerExtension({
    name: "dochub",
    version: "1.0.0",

    nodeRenderTitle: function (ctx, title) {
      var node = ctx.node, nodeClass;
      this._super(ctx, title);

      if (globals.options.ui.commentsEnabled) {
        this._local._addTopicStatus(node);
        this._local._addCommentIndicators(node);
      }

      this._local._addVersion(node);
    },

    _addVersion: function (node) {
      if (node.getLevel() === 1) {
        $("span.fancytree-title", node.span).after(
          $("<span/>", {
            "class": "version-tag",
            text: node.data.version
          }));
      }

      return node;
    },

    _addTopicStatus: function (node) {
      if (!globals.options.userLoggedIn) {
        return false;
      }

      var status = node.data.status;

      if (status && status !== "Draft") {
        $("span.fancytree-title", node.span).before(
          $("<i/>", {
            title: status,
            "class": "fa fa-circle fancytree-title-icon topic-status topic-status--" + status.toLowerCase().replace(" ", "_")
          })
        );
      }

      return node;
    },

    _addCommentIndicators: function (node) {
      if (!globals.options.userLoggedIn) {
        return false;
      }

      var template = JST["app/assets/templates/comments/toc.html"],
        classes = ["fancytree-comment-count"],
        comments = node.data.comments || 0,
        openComments = node.data.openComments || 0,
        $title = $("span.fancytree-title", node.span)

      if (node.data.isRoot) {
        if (node.data.hasDescendantComments) {
          $title.before(
            $("<i/>", { "class": "fancytree-title-icon fa fa-comments-o" })
          );
        }
        if (comments > 0) {
          $title.before(
            template({
              className: ["fancytree-title-icon"],
              comments: openComments + "/" + comments
            })
          );
        }

      }
      else {
        if (node.data.hasOpenComments) {
          classes.push("fancytree-has-open-comments");
        }

        if (node.data.hasDescendantComments) {
          $title.before(
            $("<i/>", { "class": "fancytree-title-icon fa fa-comments-o" })
          );
        }

        if (comments > 0) {
          $title.before(
            template({
              className: classes.join(" "),
              comments: comments
            })
          );
        }

      }

      return node;
    }
  });

  $.ui.fancytree.registerExtension({ name: "href", version: "1.0.0" });
});

